import { useState } from "react"
import { useNavigate } from "react-router-dom";
import { Button } from "../../../components/Button";
import { useApp } from "../../../services/app-context";
import { SignedUrlImage } from "../../../components/SignedUrlImage";
import { ReactComponent as Logo } from "../../../assets/icons/animation-logo.svg";
import { useUser } from "../../../services/user-context";
import { useAnalytics } from "../../../integrations/posthog/useAnalytics";
import { PRAXIS_PLAY_EVENTS } from "../../../integrations/posthog/events";
import { completeOnboardingSync } from "../completeOnboardingSync";
import { useTutorial } from "../../../contexts/TutorialContext";


export function Step6({ onContinue, onSkip }: { onContinue: () => void; onSkip: () => void }) {

    const { tenantProfile, styles } = useApp();
    const [loading, setLoading] = useState(false);
    const { captureEvent } = useAnalytics();
    const navigate = useNavigate();
    const { resetTutorial, skip: skipTutorial } = useTutorial();

    const { fetchRoadMap } = useUser() as any;

    const handleContinue = async () => {
        setLoading(true);
        const success = await completeOnboardingSync(fetchRoadMap, { onError: "toast" });
        if (success) {
            captureEvent(PRAXIS_PLAY_EVENTS.SURVEY_COMPLETED, {
                content_type: "onboarding",
                responses_count: "navigation",
                question_ids: "navigation",
                completion_time_ms: "navigation",
            });
            onContinue();
            resetTutorial();
            navigate("/dashboard");
        }
        setLoading(false);
    };

    const handleSkip = () => {
        skipTutorial();
        onSkip();
    };

    return (
        <div className="flex items-start gap-10 p-10 pt-12">
            <div className="flex-[2]">
                <div className="ai-logo">
                    <div
                        className={`ai-circle`}
                        style={{
                            // increase drop shadow area when speaking
                            filter:
                                `drop-shadow(0px 0px 3.039px var(--shadow-1)) drop-shadow(0px 0px 6.077px var(--shadow-2)) drop-shadow(0px 0px 24px var(--shadow-3))`,
                            backgroundColor: "#F0ECEC",
                            // transform: `scale(${voiceIntensity + 1})`,
                            boxShadow: "0px 0px 15.216px 9.47px rgba(173, 93, 57, 0.27) inset",
                            // slow down scaling and box shadow animation
                            transition: "transform 0.01s ease, box-shadow 0.2s ease",
                        }}
                    >
                        <div className="ai-logo ">
                            {styles?.logo ? <SignedUrlImage s3Key={styles?.smallLogo} bucket={tenantProfile?.assets_bucket} alt="logo" className="w-20 h-20" /> : <Logo />}
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-4 flex-[3]">
                <div>
                    <div className="flex flex-col gap-2">
                        <span className="text-text-primary text-[21px] font-medium ">Ready to be a <span className="text-primary">PraxisPro</span>?</span>
                        <span className="text-text-primary text-sm font-medium">Set yourself up for success with our guided tutorial.
                        </span>
                    </div>
                </div>
                <div className="mt-28 flex gap-2 justify-between">
                    <button className="text-[#888888]" onClick={handleSkip}>Skip</button>
                    <Button loading={loading} variant="primary" className="!rounded-full w-[240px] !h-[38px]" onClick={handleContinue}>Start PraxisPlay Tutorial</Button>
                </div>
            </div>
        </div>
    )
}